/**
 * Created By Vision CLI
 * Issues and merge requests are welcomed：https://git.code.oa.com/impage/vision
 *
 * API 参考：
 * http://vision.oa.com/docs/dev-plugin/#
 */

export default function({
  key, // {number} 用于标识每一个 action 实例的全局唯一且持久化的 key
  data, // {object} 数据表单内容
  global, // {object} 页面容器自定义的全局配置项
  meta, // {object} 页面元数据
  componentsMap, // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey, // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
}) {
  const { styleText } = data;

  const style = document.createElement('style');
  style.type = 'text/css';
  style.rel = 'stylesheet';
  try {
    // for Chrome Firefox Opera Safari
    style.appendChild(document.createTextNode(styleText));
  } catch (ex) {
    // for IE
    style.styleSheet.cssText = styleText;
  }
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(style);
}
